import React, { Component, Fragment } from 'react';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { getColumnData } from '../../../../utils/transform';
import styles from './DataTableGroup.styles';

import Button from '../../../inputs/button/Button';
import Icon from '../../../common/icon/Icon';
import ExtendedRow from '../extendedrow/ExtendedRow';

class DataTableGroup extends Component {
  state = {
    isOpen: false
  };

  static getDerivedStateFromProps(props, state) {
    if (props.filters !== state.previousFilters) {
      let isOpen = false;
      if (props.filters && props.filters.length) {
        isOpen = true;
      }
      return { isOpen, previousFilters: props.filters }
    }
    return null;
  }

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  toggleRow = (data) => {
    if(this.props.onRowExpand){
      this.props.onRowExpand(data.id)
    }
  };

  onRowClick = (event,data) => {
    if(this.props.onRowClick) {
      if(event.target.hasAttribute('data-event') || event.target.hasAttribute('expand')) {
        this.toggleRow(data);
        return;
      }
      this.props.onRowClick(data.id);
    }
  }

  renderRowData = (data, index) => {
    let selectedStyles =
      this.props.selectedRow === data.id && styles.dataSelected;
    const renderTd = (column, colIndex) => {
      let value = getColumnData(data, column);
      return (
        <div
          key={colIndex}
          title={value}
          style={{ width: `${100 / this.props.columns.length}%` }}
          className={css(styles.cell)}
        >
          {value}
        </div>
      );
    };
    return (
      <Fragment key={index}>
        <div
          className={css(styles.data, selectedStyles,data.isExpanded?styles.rowExpanded:'')}
          onClick={(e) => this.onRowClick(e,data) }
        >
          {
            <div className={css(styles.iconParent)} data-event="expand">
              <Icon
              expand={'false'}
              value={ data.isExpanded ? 'chevron-up' : 'chevron-down'}
              styles={[styles.iconExpand]}
              />
              </div>
          }
          {this.props.columns.map(renderTd)}
          {this.props.onEdit && (<div className={css(styles.btn)} onClick={e => e.stopPropagation()}>
            <Button
              styles={[
                styles.editBtn,
                selectedStyles && styles.editBtnSelected
              ]}
              onClick={() => this.props.onEdit(data)}
            >
              <Translate value="data.edit" />
            </Button>
          </div>)}
        </div>
        {(data.isExpanded)  && (
          <ExtendedRow data={data}  styles={selectedStyles ? styles.rowSelected:styles.extendedRow}/>
          )}
      </Fragment>
    );
  };

  renderBody = () => {
    let body = (
      <div className={css(styles.data)}>
        <Translate value="data.noData" className={css(styles.noData)} />
      </div>
    );
    if (this.props.data && this.props.data.length) {
      body = this.props.data.map(this.renderRowData);
    }
    return (
      <div
        className={css(
          this.props.showGroupHeader && !this.state.isOpen && styles.hide
        )}
      >
        {body}
      </div>
    );
  };

  render() {
    return (
      <Fragment>
        {this.props.showGroupHeader && (
          <div onClick={this.toggle}>
            <div className={css(styles.header)}>
              <span className={css(styles.headerTitle)}>{this.props.name}</span>
              <span
                className={css(
                  styles.headerIcon,
                  this.state.isOpen
                    ? styles.headerIconClose
                    : styles.headerIconOpen
                )}
              />
            </div>
          </div>
        )}
        {this.renderBody()}
      </Fragment>
    );
  }
}

export default DataTableGroup;



// WEBPACK FOOTER //
// ./src/components/data/datatable/datatablegroup/DataTableGroup.js